import "core-js/modules/es.array.unscopables.flat-map.js";
import { MIN_RETRIES, MAX_RETRIES, CLIENT } from './constants.mjs';
function formatErrorMessage(message) {
  let client = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CLIENT;
  return message.startsWith("".concat(client)) ? message : "".concat(client, ": ").concat(message);
}
function getErrorMessage(error) {
  return error instanceof Error ? error.message : JSON.stringify(error);
}
function getErrorCause(error) {
  return error instanceof Error && error.cause ? error.cause : undefined;
}
function combineErrors(dataArray) {
  return dataArray.flatMap(_ref => {
    let {
      errors
    } = _ref;
    return errors !== null && errors !== void 0 ? errors : [];
  });
}
function validateRetries(_ref2) {
  let {
    client,
    retries
  } = _ref2;
  if (retries !== undefined && (typeof retries !== 'number' || retries < MIN_RETRIES || retries > MAX_RETRIES)) {
    throw new Error("".concat(client, ": The provided \"retries\" value (").concat(retries, ") is invalid - it cannot be less than ").concat(MIN_RETRIES, " or greater than ").concat(MAX_RETRIES));
  }
}
function getKeyValueIfValid(key, value) {
  return value && (typeof value !== 'object' || Array.isArray(value) || typeof value === 'object' && Object.keys(value).length > 0) ? {
    [key]: value
  } : {};
}
function buildDataObjectByPath(path, data) {
  if (path.length === 0) {
    return data;
  }
  const key = path.pop();
  const newData = {
    [key]: data
  };
  if (path.length === 0) {
    return newData;
  }
  return buildDataObjectByPath(path, newData);
}
function combineObjects(baseObject, newObject) {
  return Object.keys(newObject || {}).reduce((acc, key) => {
    if ((typeof newObject[key] === 'object' || Array.isArray(newObject[key])) && baseObject[key]) {
      acc[key] = combineObjects(baseObject[key], newObject[key]);
      return acc;
    }
    acc[key] = newObject[key];
    return acc;
  }, Array.isArray(baseObject) ? [...baseObject] : {
    ...baseObject
  });
}
function buildCombinedDataObject(_ref3) {
  let [initialDatum, ...remainingData] = _ref3;
  return remainingData.reduce(combineObjects, {
    ...initialDatum
  });
}
export { buildCombinedDataObject, buildDataObjectByPath, combineErrors, formatErrorMessage, getErrorCause, getErrorMessage, getKeyValueIfValid, validateRetries };